import { deepAssign, get, isFunction, isObject } from '@ky/shared';
// import PlatformMessage from '@k18n/ky-language3';
import fromEntries from 'lodash-es/fromPairs';
import languages from './languages';
const { uiLocale, supportLangs, messages } = languages;
// 因为原来自己维护文案，后面改成平台，有些key重复，但是文案内容不一样。只能换个key，所以维护一份映射。
const keyTransform = {
    copy: 'editor_copy',
    loading: 'loading_more',
    use: 'all_use',
    changeWordOnly: 'feature_text_only',
    phoneNumber: 'all_phone_number',
    other: 'report_reason_other',
    video: 'photopick_video',
    and: 'all_and',
    eula: 'user_agreement',
    loginMessage: 'signin_tips1',
    loginReadMessage: 'i_have_read_and_agreed',
    collapse: 'fold',
    'pullRefresh.pulling': 'pull_down_refresh',
    'empty.record': 'music_recentl_empty',
    'error.brokenNet': 'music_search_no_network',
    'error.serverError': 'the_content_of_the_page_is_gone_please_refresh_and_try',
    'error.update': 'mv_upgrade_tips',
    'picture': 'picture_2',
    loginPlease: 'please_login_first',
    collect: 'community_collect',
    collected: 'community_has_collected',
    collectCanceled: 'community_has_discollected',
    networkNotConnected: 'network_disconnect',
    'apps.qq': 'share_qq',
    'apps.QZone': 'share_qzone',
    'apps.WeChat': 'all_wechat',
    'apps.WeChatTimeline': 'share_wechat_timeline',
    'apps.sina': 'str_share_to_weibo',
    'apps.kwai': 'all_kwai',
    download: 'download_text',
    'share.laws': 'report.laws',
    'share.sex': 'report_reason_vulgar',
    'no_auth': 'openPermissionToAlbum',
    'user_cancel': 'cancel',
};
export function t(lang, prefix, path, ...args) {
    const message = languages.messages[lang];
    let fullPath = prefix ? prefix + '.' + path : path;
    if (keyTransform[fullPath]) {
        fullPath = keyTransform[fullPath];
    }
    try {
        const result = message[fullPath] || get(message, fullPath) || get(message, path);
        if (isFunction(result)) {
            return result(...args);
        }
        else if (isObject(result)) {
            return path;
        }
        return result || path;
    }
    catch (e) {
        console.log('error', e);
        return path;
    }
}
const Locale = {
    lang: 'zh',
    cb: null,
    hasLang(newLang) {
        return supportLangs.includes(newLang);
    },
    normalLang(newLang) {
        if (Locale.hasLang(newLang)) {
            return newLang;
        }
        const [mainLang, area] = newLang.split('-');
        if (!area) {
            return;
        }
        const lang = supportLangs.find((lang) => lang.startsWith(mainLang));
        return lang;
    },
    use(newLang, newMessages) {
        const lang = Locale.set(newLang);
        if (!lang) {
            return;
        }
        if (newMessages) {
            this.add({ [lang]: newMessages });
        }
        Locale.cb?.(lang);
    },
    set(newLang) {
        if (Locale.lang === newLang) {
            return newLang;
        }
        Locale.lang = Locale.normalLang(newLang) || Locale.lang;
        if (Locale.lang !== newLang) {
            console.warn(`[Locale] ${newLang} is not supported, reset to ${Locale.lang}`);
        }
        return Locale.lang;
    },
    onLangChange(cb) {
        Locale.cb = cb;
    },
    add(newMessages = {}) {
        const checkedMessage = {};
        Object.entries(newMessages).forEach(([lang, messages]) => {
            const newLang = Locale.normalLang(lang);
            if (newLang) {
                checkedMessage[newLang] = messages;
            }
        });
        deepAssign(messages, checkedMessage);
    },
    addMessagesByPlatform(message) {
        const { language, textList } = message;
        const newMessages = {};
        language.forEach((lang, index) => {
            const message = fromEntries(textList.map((item) => [item.key, item.text[index]]));
            newMessages[lang] = message;
        });
        Locale.add(newMessages);
    },
    t(path, ...args) {
        return t(Locale.lang, '', path, ...args);
    },
};
Locale.addMessagesByPlatform(uiLocale);
export { supportLangs, messages };
export default Locale;
